import qs from "qs";
import { REGION_NA } from "../service/Constants";

function mapRegionToEmergencyDriverFilters(region) {
  switch (region) {
    case REGION_NA:
      return [
        {
          title: "Application",
          filters: ["driverFamilyFilter_1"]
        },
        {
          title: "Family",
          filters: ["driverFamilyFilter_3"]
        },
        {
          title: "Features",
          filters: ["driverFeature"]
        },
        {
          title: "Certifications",
          filters: ["driverCertification"]
        },
        {
          title: "Classifications",
          filters: ["driverClassification"]
        },
        {
          title: "Dimensions",
          filters: [
            "driverHousingWidth",
            "driverHousingLength",
            "driverHousingHeight"
          ]
        },
        {
          title: "Exceptions",
          filters: ["searchTermFilter"]
        }
      ];
    default: {
      return [
        {
          title: "Release state",
          filters: ["releaseState"]
        },
        {
          title: "Application",
          filters: ["driverFamilyFilter_1"]
        },
        {
          title: "Family",
          filters: ["driverFamilyFilter_3"]
        },
        {
          title: "Mounting type",
          filters: ["driverMountingType"]
        },
        {
          title: "Isolation class",
          filters: ["driverIsolationClass"]
        },
        {
          title: "Dimensions",
          filters: [
            "driverHousingWidth",
            "driverHousingLength",
            "driverHousingHeight"
          ]
        },
        {
          title: "Exceptions",
          filters: ["searchTermFilter"]
        }
      ];
    }
  }
}

export const mapEmergencyDriverFilterToType = {
  release_state: "checkbox",
  driverFamilyFilter_1: "checkbox",
  driverFamilyFilter_2: "checkbox",
  driverFamilyFilter_3: "checkbox",
  family: "checkbox",
  driverHousingWidth: "range",
  driverHousingLength: "range",
  driverHousingHeight: "range",
  searchTermFilter: "search"
};

export const mapEmergencyDriverFilterToParameter = {
  driverFamilyFilter_1: "productFamily",
  driverFamilyFilter_2: "productFamily2",
  driverFamilyFilter_3: "productFamily3",
  searchTermFilter: "searchTerm",
  driverHousingWidth: ["housingWidthMin", "housingWidthMax"],
  driverHousingLength: ["housingLengthMin", "housingLengthMax"],
  driverHousingHeight: ["housingHeightMin", "housingHeightMax"]
};

function lookupFilterToType(name) {
  return !mapEmergencyDriverFilterToType[name]
    ? "checkbox"
    : mapEmergencyDriverFilterToType[name];
}

function lookupFilterToParameter(name) {
  return !mapEmergencyDriverFilterToParameter[name]
    ? name
    : mapEmergencyDriverFilterToParameter[name];
}

function mapEmergencyDriverFilters(region, input) {
  return [
    ...mapRegionToEmergencyDriverFilters(region).map(group => {
      return {
        title: group.title,
        filters: group.filters.map(name => {
          const type = lookupFilterToType(name);
          const [filter] = input.filter(item => item.name === name);

          const emergencyDriverFilter = {
            type,
            ...filter
          };

          switch (name) {
            case "driverHousingWidth":
              emergencyDriverFilter.displayName = "Housing width";
              break;
            case "driverHousingLength":
              emergencyDriverFilter.displayName = "Housing length";
              break;
            case "driverHousingHeight":
              emergencyDriverFilter.displayName = "Housing height";
              break;
            default:
              emergencyDriverFilter.displayName = name;
              break;
          }

          return emergencyDriverFilter;
        })
      };
    })
  ];
}

/**
 *
 * @param filters
 * @param emergencyDriverSearchTerm
 * @returns
 */
function mapEmergencyDriverFilterState({
  filters,
  emergencyDriverSearchTerm,
  inputCalculations
}) {
  // Add parameters
  const parameters = {};

  if (inputCalculations) {
    if (inputCalculations.ledArrayVoltage) {
      parameters.targetVoltage = inputCalculations.ledArrayVoltage;
    }
    if (inputCalculations.maxDriverOutput) {
      parameters.maxCurrent = inputCalculations.maxDriverOutput;
    }
    if (inputCalculations.maxLedPower) {
      parameters.maxLedPower = inputCalculations.maxLedPower;
    }
    if (inputCalculations.emergencyDriverFlux) {
      parameters.targetPower = inputCalculations.emergencyDriverPower;
    }
  }

  // Add filters
  filters.forEach(group => {
    group.filters.forEach(filter => {
      const paramName = lookupFilterToParameter(filter.name);
      if (lookupFilterToType(filter.name) === "range") {
        //So if it is an range filter it will have a min and max property
        if (filter.value) {
          //if value is single value then...
          if (filter.value.min && filter.value.max) {
            //The min parameter
            parameters[paramName[0]] = filter.value.min;
            //The max parameter
            parameters[paramName[1]] = filter.value.max;
          } else {
            //What we get back from the backend
            //The min parameter
            parameters[paramName[0]] = filter.from;
            //The max parameter
            parameters[paramName[1]] = filter.to;
          }
        }
      } else {
        let filterValue = null;
        if (filter.value != null) {
          // Prevent setting a filter value that the module doesn't have.
          if (Array.isArray(filter.value)) {
            filterValue = [];
            filter.value.map(value => {
              if (
                filter.availableValues.some(
                  availableValue => availableValue.value === value
                )
              ) {
                filterValue.push(value);
              }
            });
          } else {
            filterValue = filter.value;
          }
          parameters[paramName] = filterValue;
        }
      }
    });
  });

  //Set this after all the filters are applied cause then the most recent searchTerm will be send to the backend and saved
  //If you put this before the 'Add filters forEach loop' then the saved searchTerm value will be added
  if (emergencyDriverSearchTerm) {
    parameters["searchTerm"] = emergencyDriverSearchTerm;
  } else {
    if (emergencyDriverSearchTerm === "") {
      parameters["searchTerm"] = "";
    }
  }
  return parameters;
}

function mapEmergencyDriverFilterQueryParameters(filters) {
  return (
    "?" +
    qs.stringify(
      filters.reduce((params, filter) => {
        params[filter.field] = filter.value;
        return params;
      }, {})
    )
  );
}

export {
  mapEmergencyDriverFilters,
  mapEmergencyDriverFilterState,
  mapEmergencyDriverFilterQueryParameters
};
